/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkboardTask = {
  readonly id?: number;
  name: string;
  /**
   * Due date for one-off tasks, or the recurrence anchor date for recurring tasks.
   */
  starts_on: string;
  /**
   * Task or series-default status. To update a single recurring instance, use PATCH /workboard-tasks/{id}/occurrences/.
   */
  status?: WorkboardTask.status;
  assignees?: Array<number>;
  task_managers?: Array<number>;
  link_to_related_documents?: string | null;
  file_reference_folder?: string | null;
  is_waiting?: boolean;
  recurrence_frequency?: WorkboardTask.recurrence_frequency;
  /**
   * Repeat every N days/weeks/months/years.
   */
  recurrence_interval?: number;
  /**
   * Weekdays for weekly/monthly patterns, e.g. ["MO", "TH"].
   */
  recurrence_by_weekday?: any;
  /**
   * Ordinal weekday in month: 1=first, 2=second, -1=last.
   */
  recurrence_by_setpos?: number | null;
  /**
   * Calendar day in month for monthly recurrence: 1=first day, -1=last day.
   */
  recurrence_by_monthday?: number | null;
  recurrence_ends_on?: string | null;
  recurrence_count?: number | null;
  readonly created_by?: number;
};
export namespace WorkboardTask {
  /**
   * Task or series-default status. To update a single recurring instance, use PATCH /workboard-tasks/{id}/occurrences/.
   */
  export enum status {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
  }
  export enum recurrence_frequency {
    NONE = 'none',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
  }
}

